import React from 'react';

const FileList = ({
  propName,
  propUrl,
  items
}) => (
  <div className='detail-file-list'>
    {items.map((item, index) => {
      return (
        <div
          key={index}
          className='detail-file-list__item'
        >
          <span className='detail-file-list__name' title={item[propName]}>
            {item[propName]}
          </span>

          <a
            className='detail-file-list__link'
            href={item[propUrl]}
            target='_blank'
            rel='noopener noreferrer'
          >
            visualizar
          </a>
        </div>
      )
    })}
  </div>
)

export default FileList;
